import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { uniqWith, isEqual } from 'lodash'

const initialState = {
    review: {
        List: [],
        Loading: false,
        error: "",
        count: 51,
    },
    procure: {
        List: [],
        Loading: false,
        error: "",
        count: 51,
    },
    receive: {
        List: [],
        Loading: false,
        error: "",
        count: 51,
    },
    open_loads: {
        List: [],
        Loading: false,
        error: "",
        count: 51,
    },
    open_bol: {
        List: [],
        Loading: false,
        error: "",
        count: 51,
    },
    not_approved: {
        List: [],
        Loading: false,
        error: "",
        count: 51,
    },
    activeType: "",
}

const namespacers = {
    fieldMaterial: createNamespacer("FIELD_MATERIAL")
}

const dashboardReducer = createReducer(initialState, {
    [namespacers.fieldMaterial("SET_PACKAGES")]: (state, action) => {
        let procurementList = [
            ...state.procure.List,
            ...action.payload.value,
        ]
        const activeFacility = JSON.parse(localStorage.getItem(`${state.activeType}Facility`));
        const activeFacilityId = activeFacility ? activeFacility.value : null;
        let finalProcurementList = (action.payload.type === state.activeType && action.payload.facilityId === activeFacilityId) ? procurementList : [];
        return {
            ...state,
            procure: {
                ...state.procure,
                // List: [
                //     ...state.procure.List,
                //     ...action.payload.value,
                // ],
                List: uniqWith(finalProcurementList, isEqual),
                count: action.payload.count,
            }
        }
    },
    [namespacers.fieldMaterial("SET_PACKAGES_LOADING")]: (state, action) => {
        return {
            ...state,
            procure: {
                ...state.procure,
                Loading: action.payload.value,
            }
        }
    },
    [namespacers.fieldMaterial("SET_REVIEW_PACKAGES")]: (state, action) => {
        let reviewList = [
            ...state.review.List,
            ...action.payload.value,
        ]
        const activeFacility = JSON.parse(localStorage.getItem(`${state.activeType}Facility`));
        const activeFacilityId = activeFacility ? activeFacility.value : null;
        let finalReviewList = (action.payload.facilityId === activeFacilityId) ? reviewList : [];
        return {
            ...state,
            review: {
                ...state.review,
                // List: [
                //     ...state.procure.List,
                //     ...action.payload.value,
                // ],
                List: uniqWith(finalReviewList, isEqual),
                count: action.payload.count,
            }
        }
    },
    [namespacers.fieldMaterial("SET_REVIEW_PACKAGES_LOADING")]: (state, action) => {
        return {
            ...state,
            review: {
                ...state.review,
                Loading: action.payload.value,
            }
        }
    },
    [namespacers.fieldMaterial("SET_BOMS")]: (state, action) => {
        let bomsList = [
            ...state.receive.List,
            ...action.payload.value,
        ]
        const activeFacility = JSON.parse(localStorage.getItem(`${state.activeType}Facility`));
        const activeFacilityId = activeFacility ? activeFacility.value : null;
        let finalBomList = (action.payload.type === state.activeType && action.payload.facilityId === activeFacilityId) ? bomsList : [];
        return {
            ...state,
            receive: {
                ...state.receive,
                // List: [
                //     ...state.receive.List,
                //     ...action.payload.value,
                // ],
                List: uniqWith(finalBomList, isEqual),
                count: action.payload.count,
            }
        }
    },
    [namespacers.fieldMaterial("SET_BOMS_LOADING")]: (state, action) => {
        return {
            ...state,
            receive: {
                ...state.receive,
                Loading: action.payload.value,
            }
        }
    },

    [namespacers.fieldMaterial("SET_LOADS")]: (state, action) => {
        let loadsList = [
            ...state.open_loads.List,
            ...action.payload.value,
        ]
        const activeFacility = JSON.parse(localStorage.getItem(`${state.activeType}Facility`));
        const activeFacilityId = activeFacility ? activeFacility.value : null;
        let finalLoadsList = action.payload.facilityId === activeFacilityId ? loadsList : [];
        return {
            ...state,
            open_loads: {
                ...state.open_loads,

                // List: [
                //     ...state.open_loads.List,
                //     ...action.payload.value,
                // ],
                List: uniqWith(finalLoadsList, isEqual),
                count: action.payload.count,
            }
        }
    },
    [namespacers.fieldMaterial("SET_LOADS_LOADING")]: (state, action) => {
        return {
            ...state,
            open_loads: {
                ...state.open_loads,
                Loading: action.payload.value,
            }
        }
    },

    [namespacers.fieldMaterial("SET_BOLS")]: (state, action) => {
        let bolsList = [
            ...state.open_bol.List,
            ...action.payload.value,
        ]
        const activeFacility = JSON.parse(localStorage.getItem(`${state.activeType}Facility`));
        const activeFacilityId = activeFacility ? activeFacility.value : null;
        let finalBolList = action.payload.facilityId === activeFacilityId ? bolsList : [];
        return {
            ...state,
            open_bol: {
                ...state.open_bol,
                // List: [
                //     ...state.open_bol.List,
                //     ...action.payload.value,
                // ],
                List: uniqWith(finalBolList, isEqual),
                count: action.payload.count,
            }
        }
    },

    [namespacers.fieldMaterial("SET_BOLS_LOADING")]: (state, action) => {
        return {
            ...state,
            open_bol: {
                ...state.open_bol,
                Loading: action.payload.value,
            }
        }
    },

    [namespacers.fieldMaterial("SET_NOT_APPROVED")]: (state, action) => {
        let notApprovedList = [
            ...state.not_approved.List,
            ...action.payload.value,
        ]
        const activeFacility = JSON.parse(localStorage.getItem(`${state.activeType}Facility`));
        const activeFacilityId = activeFacility ? activeFacility.value : null;
        let finalNotApprovedList = (action.payload.type === state.activeType && action.payload.facilityId === activeFacilityId) ? notApprovedList : [];
        return {
            ...state,
            not_approved: {
                ...state.not_approved,
                List: uniqWith(finalNotApprovedList, isEqual),
                count: action.payload.count,
            }
        }
    },

    [namespacers.fieldMaterial("SET_NOT_APPROVED_LOADING")]: (state, action) => {
        return {
            ...state,
            not_approved: {
                ...state.not_approved,
                Loading: action.payload.value,
            }
        }
    },

    [namespacers.fieldMaterial("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },

    [namespacers.fieldMaterial("CLEAR")]: (state, action) => {
        return {
            ...initialState,
        }
    },
    [namespacers.fieldMaterial("SET_ACTIVE_TYPE")]: (state, action) => {
        return {
            ...state,
            activeType: action.payload.value
        }
    },
})

export default dashboardReducer;
